<template>
  <div v-if="intent">
    <v-layout style="border-bottom: 1px solid #eee;" class="mb-3">
      <v-flex form-control :class="{ 'has-error': errors.has('intentName') }" class="pa-2">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('Conversation')"
          v-model="intent.intentname"
          name="intentName"
          :data-vv-as="$t('Conversation')"
          aria-describedby="Intent Name"
          v-validate="
            'required|excluded:{default},{welcome}' + (excludedName ? ',' + excludedName : '')
          "
        />
        <span class="text-error" v-show="errors.has('intentName')">
          {{
          errors.first('intentName')
          }}
        </span>
      </v-flex>
      <slot name="header"></slot>
    </v-layout>
    <div class="pa-2">
      <template
        v-if="intent.answer.length > 0 && intent.answer[0].length > 0 && intent.answer[0][0].condition"
      >
        <template v-for="(condition, index) in intent.answer[0][0].condition">
          <div :key="index" class="z-border-red pa-2 mb-2" v-if="condition.case != 'others'">
            <sub-condition-manage
              v-model="intent.answer[0][0].condition[index]"
              @onDelete="removeCondition(index)"
              :disabled=" intent.answer[0][0].condition.length <= 2"
            ></sub-condition-manage>

            <!-- <div v-for="(subcondition, sindex) in condition" :key="`${index}_${sindex}`">{{}}</div> -->
          </div>
        </template>
        <div
          class="add-conversation text-xs-center"
          style="cursor: pointer"
          @click="addCondition"
          v-if="intent.answer[0][0].condition.length <= 10"
        >
          <i class="fa fa-plus middle"></i>
          {{ $t('Add Condition') }}
        </div>
      </template>
    </div>
    <div class="text-xs-center">
      <v-btn outline color="grey" @click="onCancel">{{ $t('cancel') }}</v-btn>
      <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
    </div>
  </div>
</template>

<script>
import SubConditionManage from './SubConditionManage'
export default {
  props: ['value'],
  data() {
    return {
      excludedName: '',
      intent: null
    }
  },
  components: {
    SubConditionManage
  },
  mounted() {
    this.intent = this.value
    if (
      this.intent.answer.length == 0 ||
      this.intent.answer[0].length == 0 ||
      !this.intent.answer[0][0].condition
    ) {
      this.intent.answer = [
        [
          {
            condition: [],
            type: 'condition'
          }
        ]
      ]
    }
    this.intent = JSON.parse(JSON.stringify(this.value))
    this.cached_intent = JSON.stringify(this.intent)
  },
  methods: {
    onCancel() {
      this.intent = JSON.parse(this.cached_intent)
      this.$emit('onCancel')
    },
    onSave() {
      var conditionIndex = this.intent.answer[0][0].condition.findIndex(el => {
        return el.case == 'others'
      })
      if (conditionIndex == -1) {
        this.intent.answer[0][0].condition.push({
          case: 'others',
          caseText: 'others',
          to: 0,
          type: 'node'
        })
      }
      var sorted = this.intent.answer[0][0].condition.sort((a, b) => {
        if (b.case == 'others') {
          return -1
        } else {
          return 1
        }
      })
      if (sorted.length > 0) {
        this.$set(this.intent.answer[0][0], 'condition', sorted)
        this.$set(this.intent, 'connected_intents', [
          {
            condition: sorted
          }
        ])
      } else {
        this.$set(this.intent, 'answer', [])
        this.$set(this.intent, 'connected_intents', [])
      }
      this.$nextTick(() => {
        this.cached_intent = JSON.stringify(this.intent)

        this.$emit('onSave', this.intent)
      })
    },
    removeCondition(index) {
      this.intent.answer[0][0].condition.splice(index, 1)
      this.$forceUpdate()
    },
    addCondition() {
      this.intent.answer[0][0].condition.push({
        case: '',
        to: 0
      })
      this.$forceUpdate()
      //   this.$emit('input', this.intent)
    }
  },
  watch: {
    value() {
      this.intent = this.value
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/flow/ConditionManage.vue